import { useLocation } from "react-router-dom";
import ReviveAdultPolicy from "../../components/lapsedPolicy/ReviveAdultPolicy.tsx";
import ReviveChildPolicy from "../../components/lapsedPolicy/ReviveChildPolicy.tsx";
import { useNavigate } from "react-router-dom";
import { redirect } from "react-router-dom";
import { Navigate } from "react-router-dom";

const RevivePolicy = () => {
  const location = useLocation();
  const { isAdult, policyNo, gender } = location.state || {}; // fallback in case state is undefined

  if (!policyNo) {
    return <Navigate to="/lapsed-policies" replace />;
  }

  return (
    <div>
      {isAdult ? (
        <ReviveAdultPolicy policyNo={policyNo} gender={gender} />
      ) : (
        <ReviveChildPolicy policyNo={policyNo} gender={gender} />
      )}
    </div>
  );
};

export default RevivePolicy;
